import React from "react";
import { useTranslation } from "react-i18next";
import "./ChipNuevo.css";

/**
 * Distintivo "Nuevo" (p. ej. la nueva "Tu IA Normativa").
 * - Por defecto: chip en línea (cabeceras).
 * - `esquina`: pequeño y suave en la esquina superior derecha de una opción de menú (que debe tener la clase
 *   `menu-novedad`, que la hace `relative`); no ocupa sitio en la línea, así que no la parte ni la desborda.
 *   Al pasar el ratón por la opción salen partículas del propio chip.
 */
export default function ChipNuevo({ className = "", esquina = false }) {
  const { t } = useTranslation("nav");
  const texto = t("sidebar.new", { defaultValue: "Nuevo" });

  if (esquina) {
    return (
      <span
        className={`pointer-events-none absolute -top-1.5 right-1.5 rounded-full bg-emerald-50 px-1.5 py-[2px] text-[8px] font-semibold uppercase leading-none tracking-wide text-emerald-700 ring-1 ring-emerald-200 ${className}`}
      >
        {texto}
        <ParticulasNovedad />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-1.5 py-[3px] text-[9px] font-bold uppercase leading-none tracking-wider text-white ${className}`}
      style={{ background: "linear-gradient(135deg, #10b981 0%, #0d9488 100%)", boxShadow: "0 0 0 2px rgba(16, 185, 129, 0.18)" }}
    >
      {texto}
    </span>
  );
}

// Dirección, color y retraso de cada partícula (salen del chip al pasar el ratón por la opción `menu-novedad`)
const PARTICULAS = [
  { dx: "-16px", dy: "-10px", color: "#10b981", retraso: 0 },
  { dx: "14px", dy: "-12px", color: "#f59e0b", retraso: 120 },
  { dx: "20px", dy: "2px", color: "#14b8a6", retraso: 240 },
  { dx: "-20px", dy: "4px", color: "#f59e0b", retraso: 360 },
  { dx: "6px", dy: "-15px", color: "#10b981", retraso: 480 },
  { dx: "-6px", dy: "12px", color: "#14b8a6", retraso: 600 },
];

/** Partículas que salen del centro del chip (decorativas, sin interacción). */
function ParticulasNovedad() {
  return (
    <span className="menu-novedad__particulas" aria-hidden="true">
      {PARTICULAS.map((p, i) => (
        <span
          key={i}
          className="menu-novedad__particula"
          style={{ "--dx": p.dx, "--dy": p.dy, "--color-particula": p.color, "--retraso": `${p.retraso}ms` }}
        />
      ))}
    </span>
  );
}
